import React from "react"
export const ContentToolContext = React.createContext({})
